import { Component, OnInit, Input, EventEmitter, OnChanges, OnDestroy, Output } from '@angular/core';

@Component({
	selector: 'app-input-range',
	templateUrl: './input-range.component.html',
	styleUrls: ['./input-range.component.scss']
})
export class InputRangeComponent implements OnInit {
	@Input() min: number;
	@Input() max: number;
	@Input() value: number;
	@Input() vertical: boolean;
	@Input() step: number;

	@Output() public change = new EventEmitter<void>();

	constructor() {
	}

	ngOnInit() {
	}
}
